import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/RoleType`;

export const GetRoleTypeList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetRoleTypeList`,
    params
  );
  return res;
};

export const GetAddUpdateUserRole = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateRoleType?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetRoleTypeModel = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetRoleTypeModel?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&RoleTypeKeyID=${KeyID}`
  );
  return res;
};

export const ChangeRoleTypeStatus = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/ChangeRoleTypeStatus?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&RoleTypeKeyID=${KeyID}`
  );
  return res;
};

export const DeleteRoleType = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/DeleteRoleType?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}&RoleTypeKeyID=${KeyID}`
  );
  return res;
};
export const GetRoleTypeLookupList = async (ModuleName, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetRoleTypeLookupList?ModuleName=${ModuleName}&AdminKeyID=${AdminKeyID}`
  );
  return res;
};
